module.exports = __webpack_public_path__ + "img/case7-jpg.48368c45.jpg";